function defaultCustomFunction() {
    return document.documentElement.lang;
}
export const install = (_, opts) => {
    if (!opts?.clientId)
        return;
    if (typeof opts?.base === "object" &&
        (!opts.base.config || !opts.base.config.function)) {
        opts.base.config = { function: defaultCustomFunction };
    }
    // eslint-disable-next-line no-underscore-dangle
    window._axcb = window._axcb || [];
    // eslint-disable-next-line no-underscore-dangle
    window._axcb.push(function onAxeptionSdkLoaded() {
        if (opts.flushStoredEvents)
            opts.flushStoredEvents();
    });
    window.axeptioSettings = {
        clientId: opts.clientId,
        cookiesVersion: opts.base,
        userCookiesDomain: opts.domain,
        token: opts.token,
        jsonCookieName: "invivo_axeptio_cookies",
        authorizedVendorsCookieName: "invivo_axeptio_authorized_vendors",
        userCookiesDuration: 182, // 6 mois
        googleConsentMode: {
            default: {
                analytics_storage: "denied",
                ad_storage: "denied",
                ad_user_data: "denied",
                ad_personalization: "denied",
                wait_for_update: 500,
            },
        },
    };
    const firstScript = document.getElementsByTagName("script")[0];
    const script = document.createElement("script");
    script.async = true;
    script.src = "//static.axept.io/sdk.js";
    // eslint-disable-next-line no-unused-expressions
    firstScript.parentNode?.insertBefore(script, firstScript);
};
export function isInstalled() {
    return !!window.axeptioSettings;
}
const plugin = { install };
export default plugin;
//# sourceMappingURL=index.js.map